<template>
	<AppFieldDate
		:id="context.id"
		v-model="modelValue"
		:required="Boolean(context.required)"
		:disabled="Boolean(context.disabled)"
		:two-digit-year-century="
			context.node.props.twoDigitYearCentury as 'past' | 'future' | undefined
		"
	/>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import type { FormKitFrameworkContext } from "@formkit/core";

const props = defineProps<{
	context: FormKitFrameworkContext;
}>();

const modelValue = ref<string | undefined>();

const data = computed(() => props.context.value);

watch(
	data,
	(newValue, oldValue) => {
		if (newValue === oldValue) {
			return;
		}

		modelValue.value = newValue;
	},
	{ immediate: true },
);

watch(modelValue, async (newValue, oldValue) => {
	if (newValue === oldValue) {
		return;
	}

	await props.context.node.input(newValue);
});
</script>
